'use es6';

import { useUsageTracker } from 'marketplace-ui-tracking';
import { useCallback, useEffect, useState } from 'react';
const UsageViewTracker = ({
  active = true,
  name = 'pageview',
  properties = {}
}) => {
  const tracker = useUsageTracker();
  const [tracked, setTracked] = useState(false);
  const getComputedProperties = useCallback(() => {
    return typeof properties === 'function' ? properties() : properties;
  }, [properties]);
  useEffect(() => {
    if (active && !tracked) {
      tracker.track(name, getComputedProperties());
      setTracked(true);
    }
  }, [tracker, active, getComputedProperties, name, tracked]);
  return null;
};
export default UsageViewTracker;